// Status Conditions only ever has one row per field — keep the list in sync
// with the <select> options rendered in AutoProcessFilters.jsx.
export const STATUS_CONDITION_FIELDS = ["dcr", "subscription", "consent"];

export const PAGE_SIZE = 10;

export const REVIEW_BULK_FETCH_PAGE_SIZE = 9;
export const REVIEW_BULK_FETCH_BATCH_PAGES = 5;
export const REVIEW_BULK_FETCH_BATCH_THRESHOLD =
  REVIEW_BULK_FETCH_PAGE_SIZE * REVIEW_BULK_FETCH_BATCH_PAGES + 4;
export const REVIEW_STATUS_API_POLL_INTERVAL_MS = 15000;
export const REVIEW_MAX_POLLING_TIME_MS = 50 * 60 * 1000;
export const REVIEW_RETRY_WAIT_TIME_MS = 5000;
export const REVIEW_MAX_RETRIES = 3;

export const REVIEW_SOURCE_ALIASES = {
  eph: "eph",
  vendor: "vendor",
};

export const REVIEW_RESULT_FIELD_CONFIG = {
  eph: {
    id: ["EntityId"],
    enterpriseId: [
      "HCPUniqueId",
      "HCOUniqueId",
      "HCPReferenceId",
      "HCOReferenceId",
      "EntityId",
    ],
    name: ["Name"],
    country: ["CountryCode"],
    classificationCode: ["ClassificationCode"],
    primarySpecialty: ["Specialities"],
    firstName: ["FirstName"],
    lastName: ["LastName"],
    type: ["type"],
  },
  vendor: {
    id: ["onekeyEid", "entityId", "entity.vid__v", "entity.veevaid__v"],
    enterpriseId: [
      "onekeyEid",
      "entityId",
      "activity.activityEid",
      "individual.individualEid",
      "entity.vid__v",
      "entity.veevaid__v",
    ],
    name: [
      "workplace.usualName",
      "individual.fullName",
      "individual.displayName",
      "entity.full_name__v",
      "entity.formatted_name__v",
      "entity.corporate_name__v",
      "entity.hco_name_cda__v",
      "entity.name",
    ],
    country: [
      "country",
      "entity.primary_country__v",
      "entity.country_cda__v",
      "entity.country__v",
      "workplace.workplaceAddresses.P,1.address.postalTownReference.country",
    ],
    classificationCode: [
      "entity.hcp_type__v",
      "entity.hco_type__v",
      "individual.typeLabel",
      "entityType",
      "entity.entityType",
      "entity.hcp_type_local__v",
      "entity.hco_type_local__v",
    ],
    primarySpecialty: [
      "entity.specialty_1__v",
      "activity.typeLabel",
      "entity.spec_1_local__v",
      "entity.spec_2_local__v",
    ],
    firstName: [
      "individual.firstName",
      "entity.first_name__v",
      "entity.first_name",
    ],
    lastName: [
      "individual.lastName",
      "entity.last_name__v",
      "entity.last_name",
    ],
    type: [
      "entityType",
      "entity.entityType",
      "entity.hco_type_local__v",
      "entity.hcp_type_local__v",
    ],
  },
};

export const AUTO_PREVIEW_FIELD_COUNT = 5;

export const AUTO_ENTITY_FIELD_CONFIG = {
  HCP: {
    fields: [
      ["enterprise_id", "Enterprise ID"],
      ["country_code", "Country"],
      ["first_name", "First Name"],
      ["middle_name", "Middle Name"],
      ["last_name", "Last Name"],
      ["classification_code", "Classification Code"],
      ["primary_specialty", "Primary Specialty"],
      ["specialty_2", "Specialty 2"],
      ["specialty_3", "Specialty 3"],
      ["phone", "Phone"],
      ["email", "Email"],
      ["identifier_1_type", "Identifier 1 Type"],
      ["identifier_1_id", "Identifier 1 ID"],
      ["hcp_adrs_line_1", "Address Line 1"],
      ["hcp_adrs_line_2", "Address Line 2"],
      ["hcp_adrs_city", "City"],
      ["hcp_adrs_state_code", "State"],
      ["hcp_adrs_country", "Address Country"],
      ["hcp_adrs_zip", "ZIP"],
    ],
  },
  HCO: {
    fields: [
      ["enterprise_id", "Enterprise ID"],
      ["country_code", "Country"],
      ["name", "Name"],
      ["classification_code", "Classification Code"],
      ["primary_specialty", "Primary Specialty"],
      ["phone", "Phone"],
      ["email", "Email"],
      ["hco_adrs_line_1", "Address Line 1"],
      ["hco_adrs_city", "City"],
      ["hco_adrs_state_code", "State"],
      ["hco_adrs_country", "Address Country"],
      ["hco_adrs_zip", "ZIP"],
      ["identifier_1_type", "Identifier 1 Type"],
      ["identifier_1_id", "Identifier 1 ID"],
      ["rel_hco_enterprise_id", "Enterprise ID"],
      ["rel_hco_name", "Name"],
      ["rel_hco_clsfctn_cd", "Classification Code"],
      ["rel_hco_country_code", "Country"],
      ["rel_hco_adrs_line_1", "Address Line 1"],
      ["rel_hco_adrs_city", "City"],
    ],
  },
  PARENT_HCO: {
    fields: [
      ["enterprise_id", "Enterprise ID"],
      ["country_code", "Country"],
      ["name", "Name"],
      ["classification_code", "Classification Code"],
      ["primary_specialty", "Primary Specialty"],
      ["phone", "Phone"],
      ["email", "Email"],
      ["hco_adrs_line_1", "Address Line 1"],
      ["hco_adrs_city", "City"],
      ["hco_adrs_state_code", "State"],
      ["hco_adrs_country", "Address Country"],
      ["hco_adrs_zip", "ZIP"],
      ["identifier_1_type", "Identifier 1 Type"],
      ["identifier_1_id", "Identifier 1 ID"],
      ["rel_hco_enterprise_id", "Enterprise ID"],
      ["rel_hco_name", "Name"],
      ["rel_hco_clsfctn_cd", "Classification Code"],
      ["rel_hco_country_code", "Country"],
      ["rel_hco_adrs_line_1", "Address Line 1"],
      ["rel_hco_adrs_city", "City"],
    ],
  },
};

export const AUTO_PROGRESS_POLL_INTERVAL_MS = 10000;
export const AUTO_PROGRESS_POLL_WINDOW_MS = 2 * 60 * 1000;
export const AUTO_MANUAL_REFRESH_WINDOW_MS = 60 * 1000;

// TEMP: API doesn't return DCR/Subscription/Consent result details yet —
// static placeholder so the Auto Processed left grid keeps showing the
// status row/pill until the backend sends real values.
export const STATIC_AUTO_RESULT_DETAIL = {
  recordStatus: "pending",
  dcr: {
    status: "pending",
    dcrId: "N/A",
    shellProfileResult: "N/A",
    processedTime: "N/A",
  },
  subscription: {
    status: "pending",
    subscriptionStatus: "N/A",
    processedTime: "N/A",
  },
  consent: {
    status: "pending",
    consentStatus: "N/A",
    uploadedAt: "N/A",
    processedTime: "N/A",
  },
};
